import React from 'react';

import TextField from '../../../../forms/TextField';

export default function AdResponse() {
  return (
    <TextField
      name="icaNativeAd.adReponse"
      label="Ad Reponse JSON"
      multiline
      rows={5}
      rules={{
        required: 'Please enter an ad response.',
      }}
    />
  );
}
